<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    @closed="$refs.form.resetFields()"
    width="600px"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>充放电开关</span>
    </div>
    <el-form
      :model="model"
      ref="form"
      :rules="rules"
      label-width="90px"
    >
      <el-row>
        <el-col :span="22">
          <el-form-item
            label="密码:"
            prop="password"
          >
            <el-input
              size="small"
              v-model.trim="model.password"
              autocomplete="off"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="radio">
        <el-radio
          v-model="radio"
          label="1"
        >开</el-radio>
        <el-radio
          v-model="radio"
          label="0"
        >关</el-radio>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button
        type="primary"
        plain
        size="small"
        @click="command()"
      >确定</el-button>
      <el-button
        type="info"
        plain
        size="small"
        @click="$emit('update:visible', false)"
      >取消</el-button>

    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      radio: "1",
      order1: "",
      order2: "",
      msg: "",
      model: {
        password: "",
        commandMsg: "",
        commandType: "DISPATCH",
        vehicleId: ""
      },
      rules: {
        password: [
          {
            required: true,
            message: "密码", //this.$t("login.username_rules"),
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    async command() {
      this.model.vehicleId = this.params.vehicleId;
      this.combine(this.model.password, this.radio);
      this.model.commandMsg = this.order1;
      await this.commandDown(this.model);
      await this.$sleep(100);
      this.model.commandMsg = this.order2;
      await this.commandDown(this.model);
      this.$msg({
        showClose: true,
        message: this.msg,
        type: "success"
      });
    },
    async combine(password, type) {
      this.order1 = `<BMSSETPARA:${password},D7,000${type}>`;
      this.order2 = `<BMSSETPARA:${password},D8,000${type}>`;
    },
    async commandDown(data) {
      try {
        await this.$refs.form.validate();
        const params = {
          ...data
        };
        const { msg } = await this.$API.commandDown(params);
        this.msg = msg;
        this.$emit("update:visible", false);
      } catch (error) {
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确字段",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 30px 10px 0px 10px;
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
.radio {
  margin-left: 40px;
}
</style>
